import styled from "styled-components";
import media from "../../styles/media";

/**
 * Типографика контентных страниц. Раньше каждая страница объявляла свои
 * `Title` / `Paragraph` / `List` с чуть разными размерами — отсюда разнобой.
 */

export const PageTitle = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.h1};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.heading};

  ${media.md} {
    font-size: ${({ theme }) => theme.fontSizes.h2};
  }
`;

export const SectionTitle = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes.h3};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.heading};

  ${media.md} {
    font-size: ${({ theme }) => theme.fontSizes.xl};
  }
`;

export const Lead = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.text};

  ${media.md} {
    font-size: ${({ theme }) => theme.fontSizes.md};
  }
`;

export const Paragraph = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.text};
  white-space: pre-line;

  ${media.md} {
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }
`;

export const Eyebrow = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 22px;
  list-style: disc;
`;

export const ListItem = styled.li`
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.text};

  ${media.md} {
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }
`;

/** Вертикальный ритм внутри секции — вместо `margin-bottom` на каждом абзаце. */
export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap = 16 }) => `${$gap}px`};

  ${media.md} {
    gap: ${({ $gap = 16 }) => `${Math.max(12, $gap - 4)}px`};
  }
`;
